import UIComponent from "../component";

export class CirclePreloader extends UIComponent {
    init() {}
}
